/**
 * formatPhoneNumber
 *
 * Formats a raw phone number (digits only — as stored after the `react-imask`
 * `unmask` step) for display, grouping digits in blocks of `PHONE_GROUP_SIZE`
 * separated by a single space (Polish 3-3-3 grouping, e.g. "123456789" →
 * "123 456 789").
 *
 * For inputs whose length is not a multiple of the group size, the trailing
 * group is simply shorter — grouping always starts from the left. Empty or
 * nullish input is returned unchanged. Intentionally locale-agnostic: no
 * `Intl` / `toLocale*` usage, so the grouping is deterministic regardless of
 * runtime locale.
 */
import { PHONE_GROUP_SIZE } from '@/constants/obstructions';

export function formatPhoneNumber(value: string): string {
  if (value.length === 0) {
    return value;
  }

  const groups: string[] = [];
  for (let index = 0; index < value.length; index += PHONE_GROUP_SIZE) {
    groups.push(value.slice(index, index + PHONE_GROUP_SIZE));
  }

  return groups.join(' ');
}
